<script>
    import { onMount } from "svelte";
    import Datepicker from 'svelte-calendar';
    import InlineRadio from "../../components/inline-radio.svelte";
    import Card from "../components/card.svelte";
    import Message from "../components/message.svelte";
    import HelpIcon from "../components/helpIcon.svelte";
    
    export let mainConfig;
    export let errMsg = '';
    
    let yesNoQuestions = [
        { label: "Automatically", value: true },
        { label: "Manually", value: false },
    ];
    let title = mainConfig.classesConfig.providerId == 1 ? "Google Classrooms" : "Microsoft Teams";
    let titleIntext = mainConfig.classesConfig.providerId == 1  ? "classrooms" : "teams";
    let disableAll = false;
    let dateFormat = '#{d}/#{m}/#{Y}';
    let today  = new Date(); 
    let year = today.getFullYear();  
    let beginningJuly = new Date(year, 6, 2);
    let endOctober = new Date(year, 9, 30);
    let startOfResumeRange = new Date(year, 6 ,3);
    let endOfResumeRange = new Date(year, 9, 31 );
    let archiveDate;
    let archiveDateStr ="";
    let resumeDate;
    let errorText = false;

    //if todays date is past the october 30th, then change all years to the next year
    if(endOctober < today) {
        beginningJuly = new Date(year + 1, 6, 2);
        endOctober = new Date(year + 1, 9, 30);
        startOfResumeRange = new Date(year + 1, 6 ,3);
        endOfResumeRange =new Date(year + 1 , 9, 31 );

    }
    // NOTE: for javascript dates - months are 0 to 11. days are 1 to 31

    $:{
        console.log('archiveDate',archiveDate)
        console.log('new Date()',new Date(archiveDate))
        console.log("CHNAGES");
        archiveDateStr = new Date(archiveDate).toDateString();

        
        //ensures that the resume date cannot be set to earlier than the archival date
        if ((archiveDate != null || resumeDate != null) && (archiveDate >= resumeDate) && (mainConfig.archivalConfig.isAutoArchived == true)) {
            console.log("Inside");           

            errorText = true;
            resumeDate = new Date(archiveDate);
            resumeDate.setDate(archiveDate.getDate() + 1);
        } else {
            errorText = false;
        }

    }

    onMount(async() => {
        // console.log(mainConfig);
        disableAll = mainConfig.classesConfig.autoCreateClasses == null || mainConfig.classesConfig.autoCreateClasses == false;

        //if date exists in the config then retrive it
        if (mainConfig.archivalConfig.archiveDay != null && mainConfig.archivalConfig.archiveMonth != null )
        {
            archiveDate = new Date(year, mainConfig.archivalConfig.archiveMonth - 1, mainConfig.archivalConfig.archiveDay);
        }
        else
        {
            // if no saved archive date, set it to the default which is the 2nd of July
            archiveDate = new Date(year, 6, 2);
        }

        //if date exists in the config then retrive it
        if (mainConfig.archivalConfig.resumeDay != null && mainConfig.archivalConfig.resumeMonth != null )
        {
            resumeDate = new Date(year, mainConfig.archivalConfig.resumeMonth - 1, mainConfig.archivalConfig.resumeDay);
        }
        else
        { 
            //if no saved resumeDate, set it for the 3rd of July (default)
            resumeDate = new Date(year, archiveDate.getMonth(), archiveDate.getDate() + 1);
            resumeDate.setDate(archiveDate.getDate() + 1);
        }

    });

    const updateDates = async () => {

        if (mainConfig.archivalConfig.isAutoArchived == true && archiveDate != null)
        {
            mainConfig.archivalConfig.archiveDay = archiveDate.getDate();
            mainConfig.archivalConfig.archiveMonth = archiveDate.getMonth() + 1; 
        }

        mainConfig.archivalConfig.resumeDay = resumeDate.getDate();
        mainConfig.archivalConfig.resumeMonth = resumeDate.getMonth() + 1; 

    }

    export const ValidateClassArchival = () => {
        
        updateDates();

        if (mainConfig.archivalConfig)
        {
            if (mainConfig.archivalConfig.isAutoArchived == null)
            {
                errMsg = 'Please choose whether you want to archive classrooms automatically or manually.'
                return;
            }

            if (mainConfig.archivalConfig.isAutoArchived == true && 
                (mainConfig.archivalConfig.archiveDay == null || mainConfig.archivalConfig.archiveMonth == null) )
            {
                errMsg = 'Please choose a valid date to automatically archive classrooms.'
                return;
            }

            if (mainConfig.archivalConfig.resumeDay == null || mainConfig.archivalConfig.resumeMonth == null)
            {
                errMsg = 'Please choose a valid date to resume classrooms sync.'
                return;
            }
        }

        if (errMsg == '')
            return true;
    }

    
</script>

{#if mainConfig && mainConfig.classesConfig}

    {#if disableAll }
        <Message message="To configure {titleIntext} archival, you must choose to sync {titleIntext}."></Message>
        <br />
    {/if}

    <Card disabled={disableAll}>
        <div slot="header">  
            <h3 style="{!mainConfig.classesConfig.autoCreateClasses ? 'color: grey;' : 'color: black;'}">
                {title + " Archival"}
            </h3>
        </div>
        
        <div slot="body">

            <div class="form-group">
                <label for="autoClass" style="display:block;" class="{disableAll ? 'labeldisabled' : ''}">
                    How would you like to archive {titleIntext}?
                    <HelpIcon message="If you choose to automatically archive {titleIntext}, all your Nimbus managed {titleIntext} will be automatically archived on the date you select. Nimbus will no longer manage archived {titleIntext}." />
                </label>
                <InlineRadio id="autoArchive"
                    name="archive-classroom" 
                    options={yesNoQuestions}
                    bind:value={mainConfig.archivalConfig.isAutoArchived} 
                    disabled={disableAll}
                />
            </div>
            {#if !mainConfig.archivalConfig.isAutoArchived}
            <div class="alert alert-info mt-2" role="alert">
               <span>To ensure that any changes made on the MIS do not impact the current academic year's class data, we will temporarily suspend class sync from the 1st July each year.</span>
               <br/> <br/> 
                <span>Please be advised that it is essential to archive all classes prior to the selected date below which marks the resumption of the class sync, to prevent any loss of class data from the previous academic year.</span>
            </div>
            {/if}                

            {#if mainConfig.archivalConfig.isAutoArchived}
            <div class="form-group">
                <label id="archiveDate" for="archiveDate" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                    When would you like to archive all {titleIntext}?
                    <!-- <HelpIcon message="Helpful text." /> -->
                </label>
             
                <Datepicker start={beginningJuly} end={endOctober} format={dateFormat} style="width:100%"
                    bind:selected={archiveDate}>
                    <!-- <input type="text" class="form-control" bind:value={archiveDate}> -->
                </Datepicker>
            </div>
            <div class="alert alert-info mt-2" role="alert">
                <span>To ensure that any changes made on the MIS do not impact the current academic year's class data, we will temporarily suspend class sync from the 1st July each year.</span>
                <br/> <br/> 
                 <span>Please be advised that it is essential to archive all classes prior to the selected date below which marks the resumption of the class sync, to prevent any loss of class data from the previous academic year.</span>
             </div>
            {/if}
           
            <div class="form-group">
                <label for="newClassDate" style="display:block;" class="{disableAll ? 'labeldisabled' : ''}">
                    When would you like the new {titleIntext} to be created? Please ensure that you have selected a date after your MIS will roll over to the new academic year. 
                    <HelpIcon message="{title} sync will automatically be paused at the end of school year. 
                    This is to allow MIS data to roll over without overwriting previous year's {titleIntext} data, should you want to keep it.
                    You can choose a day to automatically resume {titleIntext} creation after your school's MIS data rolls over." />
                </label>

                <div class="input-group">
                    {#if errorText}
                    <span style="color:red; margin-bottom: 5px;">You cannot select a resume date that is before or the same as the selected archival date.</span>
                    {/if}
                    <Datepicker start={startOfResumeRange} end={endOfResumeRange} format={dateFormat} style="width:100%"
                    bind:selected={resumeDate} class="{disableAll ? 'disabled' : ''}"  />
                </div>
            </div>
        </div>
    </Card>
{/if}

{#if errMsg != ''}
    <div style="margin-top: 5px;">
        <span style="color:red;">{errMsg}</span>
    </div>
{/if}